import { render, staticRenderFns } from "./cUpdatezip.vue?vue&type=template&id=0624d474&scoped=true"
import script from "./cUpdatezip.vue?vue&type=script&lang=js"
export * from "./cUpdatezip.vue?vue&type=script&lang=js"
import style0 from "./cUpdatezip.vue?vue&type=style&index=0&id=0624d474&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0624d474",
  null
  
)

export default component.exports